import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { contentApiTypes } from './types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

const TOAST_ID = 'content-remove-category';

export const removeContentCategory = ({
  id,
  pageId,
}: Pick<contentApiTypes.RemoveCategoryParams, 'id' | 'pageId'>) => {
  return axios.delete(`/content/categories/${id}`, { params: { pageId } });
};

type RemoveContentCategoryOptions = {
  pageId?: string;
  config?: MutationConfig<typeof removeContentCategory>;
};

export const useRemoveContentCategory = ({
  pageId,
  config = {},
}: RemoveContentCategoryOptions = {}) => {
  const { onSuccess, onMutate, onError, ...restConfig } = config;

  return useMutation({
    ...restConfig,
    mutationFn: removeContentCategory,
    onMutate: (variables) => {
      toasts.loadingToast.loading(TOAST_ID, 'Удаление...');
      return onMutate?.(variables);
    },
    onSuccess: (data, variables, context) => {
      toasts.loadingToast.success(TOAST_ID, 'Категория удалена');
      if (pageId) {
        queryClient.invalidateQueries(['content-categories', pageId]);
      }
      onSuccess?.(data, variables, context);
    },
    onError: (error: AxiosError<{ error: string }>, variables, context) => {
      toasts.loadingToast.error(TOAST_ID, error.response?.data?.error);
      onError?.(error, variables, context);
    },
  });
};
